import { render } from "./Profil.vue?vue&type=template&id=5364d5be"
import script from "./Profil.vue?vue&type=script&lang=js"
export * from "./Profil.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__